<template>
  <td :id="uid" class="d-flex justify-content-center flex-column table-cell TableCell">
    <span
      class="d-flex align-items-center cell-wrapper"
      :class="{capitalize}"
    >
      <span class="name-wrapper">
        <span class="name">
          <span :class="skeletonClass">
            <slot></slot>
          </span>
        </span>
      </span>
    </span>

    <div class="sub-cell-wrapper">
      <slot name="sub-cell"></slot>
    </div>
  </td>
</template>

<script>

export default {
  name: "TableCell",
  props: {
    isRecursive: {
      type: Boolean,
      required: false,
    },
    uid: {
      type: String,
      required: false,
    },
    capitalize: {
      type: Boolean,
      required: false,
    },
    skeletonClass: {
      type: String,
      required: false,
    },
  },
}

</script>

<style>

.TableCell .FormCheckbox {
  padding: 4px;
}

</style>

<style scoped>

td {
  padding: 0 !important;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
  border: none;
  background-color: #FBFBFB !important;
}

td + td {
  border-left: 1px solid #EFEFF0;
}

.cell-wrapper {
  padding: 4.5px 12px;
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.sub-cell-wrapper {
  background-color: white;
}

.name-wrapper { 
  display: block;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}


</style>
